import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, ExternalLink } from 'lucide-react';

// 푸터 컴포넌트 - 연락처 정보와 링크 제공
const Footer: React.FC = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* 회사 정보 */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold text-white">비즈니스커리어컨설팅</h3>
            <p className="text-gray-300 text-sm leading-relaxed">
              ChatGPT 활용 교육 전문가로서<br />
              취업, 창업, 업무 효율성 향상을 위한<br />
              실무 중심 교육을 제공합니다.
            </p>
            <div className="flex space-x-4">
              <a 
                href="https://blog.example.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-white transition-colors"
              >
                <ExternalLink className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* 빠른 링크 */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold text-white">빠른 링크</h3>
            <ul className="space-y-2">
              <li>
                <Link 
                  to="/" 
                  className="text-gray-300 hover:text-white transition-colors text-sm"
                >
                  홈페이지
                </Link>
              </li>
              <li>
                <Link 
                  to="/b2b" 
                  className="text-gray-300 hover:text-white transition-colors text-sm"
                >
                  B2B 강의섭외
                </Link>
              </li>
              <li>
                <Link 
                  to="/b2c" 
                  className="text-gray-300 hover:text-white transition-colors text-sm"
                >
                  B2C 챌린지
                </Link>
              </li>
            </ul>
          </div>

          {/* 연락처 정보 */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold text-white">연락처</h3>
            <div className="space-y-3">
              <div className="flex items-center space-x-3">
                <Phone className="w-4 h-4 text-primary-400" />
                <a 
                  href="tel:010-9321-0093" 
                  className="text-gray-300 hover:text-white transition-colors text-sm"
                >
                  010-9321-0093
                </a>
              </div>
              <div className="flex items-center space-x-3">
                <Mail className="w-4 h-4 text-primary-400" />
                <a 
                  href="mailto:ohdana0808@daum.net" 
                  className="text-gray-300 hover:text-white transition-colors text-sm"
                >
                  ohdana0808@daum.net
                </a>
              </div>
              <div className="flex items-start space-x-3">
                <MapPin className="w-4 h-4 text-primary-400 mt-0.5" />
                <span className="text-gray-300 text-sm">
                  부산시 북구 상학로35<br />
                  105동 2601호
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* 하단 구분선 및 저작권 */}
        <div className="border-t border-gray-800 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-400 text-sm">
              © 2024 비즈니스커리어컨설팅. All rights reserved.
            </p>
            <p className="text-gray-400 text-sm">
              대표: 오예림 | 사업자등록번호: 123-45-67890
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;


